import React from 'react';
import classNames from 'classnames';
import './StepNav.styl';

export default class StepNav extends React.PureComponent {
  render() {
    // TODO: a must be replaced with button and eslint ignore must be removed
    /* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
    return (
      <div className="step-nav">
        {this.props.steps.map((step, i) => (
          <a
            key={i}
            title={step}
            onClick={() => this.props.changeStep(i)}
            href="javascript:"
            className={classNames({
              current: this.props.current === i,
              finished: i < this.props.current,
            })}>
            {i + 1}
          </a>
        ))}
      </div>
    );
  }
}
